<template>
    <div class="main-page">
        <div class="content">
            <div>
                <div style="padding: 0 4px;">
                    <div class="info-box">
                        <img class="avatar" src="../../assets/icon/me-top.png" />
                        <div class="user-info">
                            <div class="nickname">{{ GLOBAL.lanLocal['name'] }}: <span>{{ GLOBAL.userInfo.name }}</span></div>
                            <div class="username">{{ GLOBAL.lanLocal['id'] }}: <span>{{ GLOBAL.userInfo.accountid }}</span></div>
                        </div>
                        <div class="my-auto" style="display: flex;align-items: center;flex: 1;justify-content: flex-end;"
                            v-if="this.GLOBAL.userInfo.name">
                            <img @click="logout" class="logout-img" :src="require('../../assets/signout.png')" alt="">
                        </div>
                    </div>
                    <div class="data">
                        <div class="data-item" style="width:100%;">
                            <div class="title">{{ GLOBAL.lanLocal['amount'] }}</div>
                            <div class="data-content">
                                <img src="../../assets/coin.png" />
                                <div class="data-num">{{ amount }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="info-tips">{{ GLOBAL.lanLocal['share'] }}</div>
                <div class="s-box">
                    <div class="link">
                        <div class="login-info-item">
                            <div class="v-box">
                                <input readonly="readonly" class="v-input" type="text" :value="shareUrl" />
                            </div>
                        </div>
                    </div>
                    <div class="button">
                        <input class="login-button" type="button" :data-clipboard-text="shareUrl" @click="copy"
                            :value="GLOBAL.lanLocal['copy']" />
                    </div>
                </div>
                <div style="text-align: center;">
                    <img style="margin-top: 12px;" :src="qrcodeUrl" />
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import Clipboard from 'clipboard'
import { doPost } from '../../api/api.js'
import md5 from 'js-md5';
export default {
    name: 'my',
    data() {
        return {
            money: '',
            moneyfocus: false,
            innerHeight: 0,
            tabIndex: 0,
            shareUrl: '',
            qrcodeUrl: ''
        }
    },
    watch: {
        amount: {
            immediate: true,
            handler(newValue, oldValue) {
            }
        },
    },
    props: {
        amount: {
            type: String,
            default: '0.00'
        }
    },
    computed: {
        loginClass() {
            return {
                'v-label-active': this.moneyfocus
            }
        },
    },
    created() {
        this.innerHeight = window.innerHeight - 130
        this.getShareInfo()
    },
    methods: {
        logout() {
            this.$emit("logout")
        },
        getShareInfo() {
            doPost({
                n: 'AppShare',
                a: 'get_url_info',
                accountid: this.GLOBAL.userInfo.accountid
            }).then((res) => {
                if (res.code === 0) {
                    let data = res.data;
                    this.shareUrl = data.share
                    // this.shareUrl = data.share_full
                    this.qrcodeUrl = `${this.GLOBAL.apiUrl}?n=AppShare&a=get_share_qrcode&url=${this.shareUrl}`

                }
            })
        },
        copy() {
            var clipboard = new Clipboard('.login-button')
            clipboard.on('success', e => {
                this.$toast.success('คัดลอกสำเร็จ', {
                    position: "top-center",
                    timeout: 2000,
                    closeOnClick: true,
                    pauseOnFocusLoss: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 0.6,
                    showCloseButtonOnHover: false,
                    hideProgressBar: true,
                    closeButton: false,
                    icon: true,
                    rtl: false
                });
                clipboard.destroy()
            })
            clipboard.on('error', e => {

                this.$toast.error('ระบบไม่รองรับการทำซ้ำ', {
                    position: "top-center",
                    timeout: 2000,
                    closeOnClick: true,
                    pauseOnFocusLoss: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 0.6,
                    showCloseButtonOnHover: false,
                    hideProgressBar: true,
                    closeButton: false,
                    icon: true,
                    rtl: false
                });
                clipboard.destroy()
            })
        },
        moneyFocus() {
            this.$refs.money.focus()
            this.moneyfocus = true
        },
        doWithdraw() {
            alert('success')
        },
        close() {
            this.$emit('close')
        },
    }
}
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.main-page {
    height: 100%;
    width: 100%;
    padding: 60px 6px 80px;
    box-sizing: border-box;
    background-color: rgb(17, 18, 22);
    text-align: left;
}

.login-page {
    height: 100%;
    width: 100%;
    background-color: #000;
}

.login-logo {
    padding-top: 2rem;
    text-align: center;
}

.login-logo-img {
    width: 250px;
    height: 250px;
}

.button-box {
    margin-top: 24px;
}

.login-info-item {
    text-align: left;
    background:rgb(44, 52, 62);
    height: 40px;
    border-radius: 6px;
    position: relative;
    display: flex;
    align-items: center;
}

.v-label {
    position: absolute;
    left: 20px;
    font-size: 16px;
    top: 17px;
    height: 20px;
    line-height: 20px;
    letter-spacing: normal;
    -webkit-animation: v-shake .6s cubic-bezier(.25, .8, .5, 1);
    animation: v-shake .6s cubic-bezier(.25, .8, .5, 1);
    transform-origin: top left;
}

.v-box {
    padding: 0 10px;
    width: 100%;
}

.v-input {
    width: 100%;
    color: #fff;
    background: transparent;
    border: 0;
    font-size: 16px;
    height: 20px;
    line-height: 20px;
    letter-spacing: normal;
}

.login-info-item input:focus {
    outline: none;
}

.msg-box {
    min-height: 20px;
    overflow: hidden;
    margin: 0 40px 8px 40px;
    position: relative;
}

.login-info-message {
    min-height: 14px;
    padding: 0 12px;
    color: #fff;
    line-height: 12px;
    word-break: break-word;
    word-wrap: break-word;
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
    font-size: 12px;
    text-align: left;
}

.forget-passcode {
    word-break: break-word;
    word-wrap: break-word;
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
    font-size: 14px;
    position: absolute;
    right: 1.5rem;
    bottom: 0;
    color: #fff;
}

.error-info {
    color: #dd2c00 !important;
    caret-color: #dd2c00 !important;
}

.normal-info {
    color: #1976d2 !important;
    caret-color: #1976d2 !important;
}

.theme-dark {
    color: #fff;
}

.v-label-active {
    transform: translateY(-10px) scale(.75);
}

.logout-img {
    width: 30px;
    height: 30px;
    -o-object-fit: contain;
    object-fit: contain;
}

@-webkit-keyframes v-shake {
    59% {
        margin-left: 0
    }

    60%,
    80% {
        margin-left: 2px
    }

    70%,
    90% {
        margin-left: -2px
    }
}

@keyframes v-shake {
    59% {
        margin-left: 0
    }

    60%,
    80% {
        margin-left: 2px
    }

    70%,
    90% {
        margin-left: -2px
    }
}

.login-button {
    background-color: unset;
            background-image: url('../../assets/copy-btn.png');
            background-size: 100% 100%;
    color: #212121 !important;
    font-weight: 400;
    box-shadow: unset;
    height: 44px;
    padding: 0 19.5555555556px;
    width: 100%;
    font-size: 16px !important;
    letter-spacing: 0 !important;
    transition: all .2s cubic-bezier(.02, .54, .58, 1);
    border: none;
    font-family: Noto Sans Thai;
    padding: 0 20px;
    text-align: center;
}

.button-color1 {
    background: linear-gradient(180deg, #8be0ff, #009dd8) !important;
}

.login-button-disable {
    background-color: hsla(0, 0%, 100%, .12) !important;
    text-shadow: 0 0 #000;
    opacity: .5 !important;
    color: hsla(0, 0%, 100%, .3) !important;
}

.page-title {
    padding: 1rem 24px;
    font-weight: 500;
    font-size: 30px;
    color: #fff;
    position: relative;
    text-align: left;
    margin-left: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title-img {
        width: 30px;
        aspect-ratio: auto 30 / 30;
        height: 30px;
    }

    .close {
        .v-icon {
            align-items: center;
            display: inline-flex;
            font-feature-settings: "liga";
            font-size: 24px;
            justify-content: center;
            letter-spacing: normal;
            line-height: 1;
            position: relative;
            text-indent: 0;
            transition: .3s cubic-bezier(.25, .8, .5, 1), visibility 0s;
            vertical-align: middle;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }
    }
}

.v-tab:before {
    bottom: 0;
    content: "";
    left: 0;
    opacity: 0.24;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    transition: .3s cubic-bezier(.25, .8, .5, 1);
}

.page-tab {
    display: flex;
    justify-content: space-around;
    flex: 1 0 auto;
    position: relative;
    transition: .3s cubic-bezier(.25, .8, .5, 1);
    white-space: nowrap;
    color: hsla(0, 0%, 100%, .6);

    .tab-item {
        align-items: center;
        cursor: pointer;
        display: flex;
        flex: 0 1 auto;
        font-size: .875rem;
        font-weight: 500;
        justify-content: center;
        letter-spacing: .0892857143em;
        line-height: normal;
        min-width: 90px;
        outline: none;
        padding: 0 16px;
        position: relative;
        text-align: center;
        text-decoration: none;
        text-transform: uppercase;
        transition: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        white-space: normal;
        border-bottom: 1px solid #000;

        .tab-img {
            width: 30px;
            aspect-ratio: auto 30 / 30;
            height: 30px;
            margin-right: 8px !important;
        }
    }
}

.tab-active {
    color: #ffe66f !important;
    border-bottom: 1px solid #ffe66f !important;
}

.container {
    width: 100%;
    margin-top: 24px;
    margin-right: auto;
    margin-left: auto;
}

.alert-show {
    padding: 0.5rem;
    text-align: center;
    background: #948741;
    border: 1px solid #ffe247;
    box-sizing: border-box;
    border-radius: 3px;
    max-width: 360px;
    width: 100%;
    margin: auto;
    color: #fff;
}

.profile-content {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;

    .item-container {
        display: flex;

        .item {
            color: #fff;
            position: relative;
            font-weight: 700;
            font-size: 18px;
            border-radius: 30px;
            margin: 2px;
            padding: 5px 0.5rem 5px 1.5rem;
            margin-right: 0.5rem;

            .item-img {
                position: absolute;
                top: 50%;
                left: 5px;
                width: 30px;
                height: 30px;
                -o-object-fit: contain;
                object-fit: contain;
                transform: translate(-50%, -50%);
                filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, .658));
            }

            .v-btn {
                background: none !important;
                box-shadow: none !important;
                width: 20px;
                height: 20px;
                font-size: .875rem;
                color: #fff;
                align-items: center;
                border: none;
                display: inline-flex;
                flex: 0 0 auto;
                font-weight: 500;
                letter-spacing: .0892857143em;
                justify-content: center;
                outline: 0;
                position: relative;
                text-decoration: none;
                text-indent: 0.0892857143em;
                text-transform: uppercase;
                transition-duration: .28s;
                transition-property: box-shadow, transform, opacity;
                transition-timing-function: cubic-bezier(.4, 0, .2, 1);
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
                vertical-align: middle;
                white-space: nowrap;
            }

            .v-btn:before {
                background-color: currentColor;
                border-radius: inherit;
                bottom: 0;
                color: inherit;
                content: "";
                left: 0;
                opacity: 0;
                pointer-events: none;
                position: absolute;
                right: 0;
                top: 0;
                transition: opacity .2s cubic-bezier(.4, 0, .6, 1);
            }

            .v-btn:hover:before {
                opacity: .08;
            }

            .v-btn__content {
                align-items: center;
                color: inherit;
                display: flex;
                flex: 1 0 auto;
                justify-content: inherit;
                line-height: normal;
                position: relative;
                transition: inherit;
                transition-property: opacity;

                .v-icon {
                    color: #fff;
                    font-size: 18px;
                    height: 24px;
                    width: 24px;
                    align-items: center;
                    display: inline-flex;
                    font-feature-settings: "liga";
                    justify-content: center;
                    letter-spacing: normal;
                    line-height: 1;
                    position: relative;
                    text-indent: 0;
                    transition: .3s cubic-bezier(.25, .8, .5, 1), visibility 0s;
                    vertical-align: middle;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                }
            }
        }
    }
}

.dialog-deposit-select {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    max-width: 432px;
    margin: auto;

    .item-select {
        text-align: center;
        max-width: 200px;
        width: 45%;
        margin: 0.5rem;
        padding: 5px;
        background: linear-gradient(180deg, #38d851, #0f6a00);
        box-sizing: border-box;
        border-radius: 8px;

        >a {
            display: flex;
            justify-content: flex-start;
            color: #fff;
            cursor: pointer;

            >img {
                width: 40px;
                height: 40px;
                margin: 0;
            }

            >span {
                padding-left: 8px !important;
                margin: auto 0;
            }
        }
    }
}

.content {
    margin-top: 10px;

    .info-box {
        padding: 14px 0;
        display: flex;
        align-items: center;
        // justify-content: space-between;
        box-sizing: border-box;

        .avatar {
            width: 50px;
            height: 50px;
        }

        .user-info {
            font-size: 0;
            padding-left: 10px;
            text-align: left;

            .username,
            .nickname {
                color: rgb(125, 140, 159);
                font-size: 16px;
                span {
                    color: #fff;
                }
            }
        }
    }

    .data {
        width: 100%;
        border-radius: 8px;
        background-image: url('../../assets/amount-bg.png');
        background-size: 100% 100%;
        display: flex;

        .data-item {
            width: 100%;
            padding: 6px 12px 20px;

            .title {
                font-weight: 700;
                color: rgb(125, 140, 159);
            }

            .data-content {
                margin-top: 15px;
                display: flex;
                align-items: center;
                justify-content: center;

                >img {
                    height: 50px;
                    width: 50px;
                    margin-right: 8px;
                }

                .data-num {
                    font-weight: 600;
                    font-size: 28px;
                    color: rgb(255, 198, 37);
                }
            }
        }

        .v-divider--vertical {
            align-self: stretch;
            border: solid;
            border-width: 0 thin 0 0;
            display: inline-flex;
            height: inherit;
            min-height: 100%;
            max-height: 100%;
            max-width: 0;
            width: 0;
            vertical-align: text-bottom;
            margin: 0 -1px;
            border-color: hsla(0, 0%, 100%, .12);
        }
    }

    .income {
        margin-top: 24px;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .income-item {
            color: white;

            .title {
                font-weight: 500;
                font-size: 16px;
            }

            .amount {
                color: #ffeb3b !important;
                caret-color: #ffeb3b !important;
                font-weight: 500;
                font-size: 28px;
            }

            >img {
                height: 110px;
                width: 110px;
            }
        }
    }

    .opt {
        margin-top: 12px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        box-sizing: border-box;

        .opt-item {
            width: 50%;
            padding: 12px;

            .tips {
                color: #fff;
                font-size: 12px;
            }
        }
    }

    .info {
        margin-top: 8px;
        padding-left: 12px;
        color: hsla(0, 0%, 100%, .7);
        font-weight: bold;
        font-size: 16px;
        text-align: left;
    }

    .info-tips {
        margin-top: 10px;
        padding-left: 12px;
        color: rgb(125, 140, 159);
        font-size: 14px;
        text-align: left;
    }

    .s-box {
        margin-top: 5px;
        display: flex;
        box-sizing: border-box;

        .link {
            padding: 0 4px;
            flex: 1;
        }

        .button {
            padding: 0 4px;
            height: 42px;
            width: 62px;

            >input {
                padding: 0 !important;
                height: 40px !important;
                width: 100%;
            }
        }
    }
}
</style>
  


// WEBPACK FOOTER //
// src/components/my/my.vue